import { Link } from 'react-router-dom';
import { css, cx } from '@emotion/css';

interface NavigationItemProps {
  to: string;
  label: string;
  isActive: boolean;
  disabled?: boolean;
}

const NavigationItem: React.FC<NavigationItemProps> = ({ to, label, isActive, disabled }) => {
  if (disabled) {
    return (
      <div className={linkStyle}>
        <div
          className={cx(styleHSBC, disabledStyle)}
        >
          {label}
        </div>
      </div>
    );
  }
  return (
    <Link to={to} className={linkStyle}>
      <div
        className={cx(styleHSBC, {
          [activeStyle]: isActive,
          [disabledStyle]: disabled,
        })}
      >
        {label}
      </div>
    </Link>
  );
};

export default NavigationItem;
const linkStyle = css`
  text-decoration: none;
  margin-right: 8px;
`;

const styleHSBC = css`
  padding: 4px 12px;
  border-radius: 60px;
  color: #FFF;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  font-variation-settings: 'wght' 400;
  letter-spacing: 0.2px;
  white-space: nowrap;
`;

const activeStyle = css`
  font-variation-settings: 'wght' 600;
  background: #2D3446;
  font-weight: 600;
`;

const disabledStyle = css`
  opacity: 0.5;
  cursor: not-allowed;
`;